import React from 'react'
import loader from '../assets/images/website/infiniteSpinner.svg'
function AppLoader() {
  return (
    <div className='app-loader'>
        <img src={loader}/>
    </div>
  )
}

export default AppLoader